import React, { useEffect } from "react";
import Comment from "../Comment/Comment";
import PropTypes from "prop-types";
import { CommentPropType, ItemPropType } from "../../PropTypes";

function CommentList(props) {
  useEffect(() => {
    window.addEventListener('youtubeVideoPlay', e => {
      // Loop through all videos that aren't the target and pause them
      document.querySelectorAll('iframe[src^="https://www.youtube"]').forEach(video => {
        if (video.id !== e.target.id) {
          const player = YT.get(video.id);
          player && player.pauseVideo();
        }
      });
    });
  });

  if (props.comments) {
    return (
      <div
        className={`ugc-comments-list ${props.isReply ? 'ugc-comment__replies-wrapper' : ''}`}>
        {
          props.isReply &&
          <span>
            {props.comments.length} {props.comments.length === 1 ? 'reply' : 'replies'}
          </span>
        }
        {
          props.comments.map((comment, i) => (
            <Comment
              profilePage={props.profilePage}
              isReply={props.isReply}
              key={comment.id}
              externalId={props.externalId}
              comment={comment}
              item={ props.item }
              maxChars={props.maxChars}
              index={i}/>
          ))
        }
      </div>
    );
  } else {
    return false;
  }
}

CommentList.propTypes =
  {
    skip: PropTypes.number,
    top: PropTypes.number,
    setSkip: PropTypes.func,
    externalId: PropTypes.string,
    comments: PropTypes.arrayOf(CommentPropType),
    item: ItemPropType | null
  };

export default CommentList;
